define('views/components/recurring_customer_product_compact/recurring_product_list',['require','views/base/list_view','views/components/recurring_customer_product_compact/recurring_product','text!templates/components/recurring_customer_product_compact/recurring_product_list.html'],function (require) {
  var BaseListView = require("views/base/list_view");
  var ChildView = require("views/components/recurring_customer_product_compact/recurring_product");

  var temp = require("text!templates/components/recurring_customer_product_compact/recurring_product_list.html");
  return BaseListView.extend({
    template: _.template(temp),
    childView: ChildView,
  });
});

